import React, { useState } from "react";
import axios from "axios";
import "./Rag.css";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://rag-backend-glwx.onrender.com";

function Rag() {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleQuery = async () => {
    if (!question.trim()) return;
    setLoading(true);
    setError("");
    setAnswer("");
    setSources([]);

    try {
      const res = await axios.post(`${BACKEND_URL}/query`, { question });
      setAnswer(res.data.answer);
      setSources(res.data.sources || []);
    } catch (e) {
      console.error(e);
      if (e.response?.status === 405) {
        setError("Server rejected the request (405). Check that REACT_APP_BACKEND_URL is set correctly.");
      } else if (e.response?.status === 422) {
        setError("Invalid request format (422). The server couldn't parse the question.");
      } else if (e.code === "ERR_NETWORK") {
        setError("Cannot reach the server. It may be starting up — wait 30 seconds and try again.");
      } else {
        setError(`Error: ${e.response?.status || e.message}. Please try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !loading) handleQuery();
  };

  return (
    <div className="rag-container">
      <header className="rag-header">
        <h1>React RAG App</h1>
        <p>Interview QA Assistant</p>
      </header>

      <main className="rag-main">
        <div className="input-section">
          <input
            type="text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Ask about React, CSS, JS interviews..."
            disabled={loading}
            className="query-input"
          />
          <button
            onClick={handleQuery}
            disabled={loading || !question.trim()}
            className="query-btn"
          >
            {loading ? <div className="spinner"></div> : "Query"}
          </button>
        </div>

        {error && (
          <section className="error-section">
            <p className="error-message">⚠️ {error}</p>
          </section>
        )}

        {answer && (
          <section className="answer-section">
            <h3>Answer</h3>
            <div className="answer-content">{answer}</div>
          </section>
        )}

        {sources && sources.length > 0 && (
          <section className="sources-section">
            <h4>Sources ({sources.length})</h4>
            <ul className="sources-list">
              {sources.map((sourceObj, index) => {
                const sourceText =
                  sourceObj?.source ||
                  (typeof sourceObj === "string"
                    ? sourceObj
                    : JSON.stringify(sourceObj).slice(0, 200) + "...");
                return (
                  <li key={index} className="source-item">
                    {sourceText}
                    {sourceObj?.score && (
                      <span className="score-badge">
                        ({(sourceObj.score * 100).toFixed(1)}%)
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </section>
        )}
      </main>
    </div>
  );
}

export default Rag;